import React, { useContext } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import ComponentContext from "../Context";
import Pajoohyar from "../Images/Pajoohyar.png";

const Header = () => {
  const context = useContext(ComponentContext);

  return (
    <header className="myHeader bg-light">
      {/* <ScrollableAnchor id="gotop"> */}
      <Container className="bg-light">
        <Navbar
          bg="light"
          variant="light"
          id="myNavbar"
          expand="lg"
          style={{ zIndex: 100 }}>
          <Navbar.Brand href="https://pajoohyar.ir">
            <img height={40} alt="pajoohyar" src={Pajoohyar} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto">
              <Nav.Link href="/">صفحه اصلی</Nav.Link>
              <NavDropdown title="دانلود" className="custom-dropdown">
                <NavDropdown.Item href="/product">
                  دانلود پژوهیار
                </NavDropdown.Item>
                <NavDropdown.Item href="/extensions">
                  افزونه مرورگر
                </NavDropdown.Item>
                <NavDropdown.Item href="/metadata">فراداده</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title="کاربردی" className="custom-dropdown">
                <NavDropdown.Item href="/supported-sites">
                  پایگاه‌های پشتیبانی شده
                </NavDropdown.Item>
                <NavDropdown.Item href="/csl">شیوه‌نامه‌ها</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title="آموزش" className="custom-dropdown">
                <NavDropdown.Item href="/help">راهنما</NavDropdown.Item>
                <NavDropdown.Item href="/faq">پرسش‌های متداول</NavDropdown.Item>
                <NavDropdown.Item href="/workshop">کارگاه</NavDropdown.Item>
              </NavDropdown>

              <Nav.Link href="/blog">بلاگ </Nav.Link>
              <NavDropdown title="پژوهیار آنلاین" className="custom-dropdown">
                {/* <NavDropdown.Item href="https://mylib.pajoohyar.ir">
                  کتابخانه آنلاین
                </NavDropdown.Item> */}
                <NavDropdown.Item href="/cite">
                  استناددهی آنلاین
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link href="https://cloud.pajoohyar.ir/">
                ابر پژوهیار
              </Nav.Link>
              {context.profile ? (
                <NavDropdown
                  title={`${context.profile.full_name} خوش آمدید!`}
                  className="custom-dropdown">
                  <NavDropdown.Item href="https://accounts.inoor.ir/">
                    مشاهده پروفایل
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      context.cookie.remove("pajoohyar_access_token");
                      context.cookie.remove("pajoohyar_expires_at");
                      context.cookie.remove("pajoohyar_profile");
                      context.ApiDriver.access_token = null;
                      context.ApiDriver.expires_at = null;
                      context.profile = null;
                      setTimeout(() => {
                        window.location = "/";
                      }, 500);
                    }}>
                    خروج
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <Nav.Link
                  href={`https://core.pajoohyar.ir/inoor/login?context=2&data=${JSON.stringify(
                    { redirect_url: encodeURI(document.location.pathname) },
                  )}`}
                  className="login">
                  ورود
                </Nav.Link>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
      {/* </ScrollableAnchor> */}
    </header>
  );
};

export default Header;
